/**
 * @component HeaderTitle
 * @description
 * Componente que muestra el título del encabezado de una tabla y un campo de búsqueda.
 * Es usado comúnmente como parte del encabezado principal de tablas avanzadas.
 *
 * El campo de búsqueda (`AdvanceTableSearchBox`) permite filtrar los datos globalmente
 * dentro de la tabla utilizando el estado `globalFilter` proporcionado por `react-table`.
 *
 * @param {Object} props - Props del componente.
 * @param {string} props.globalFilter - Valor actual del filtro global de búsqueda.
 * @param {Function} props.setGlobalFilter - Función para actualizar el valor del filtro global.
 *
 * @returns {JSX.Element} Componente con el título y buscador.
 *
 * @example
 * <HeaderTitle
 *   globalFilter={globalFilter}
 *   setGlobalFilter={setGlobalFilter}
 * />
 */

import React from 'react';
import { Row, Col } from 'react-bootstrap';

import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const HeaderTitle = ({ globalFilter, setGlobalFilter }) => (
    <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
            <h6 className="mb-0">Usuarios</h6>
        </Col>
        <Col xs="auto">
            <AdvanceTableSearchBox
                className="input-search-width"
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                placeholder="Buscar"
            />
        </Col>
    </Row>
);

export default HeaderTitle;